const STATE_ALIASES = new Map([
  ["gujrat", "Gujarat"],
  ["gujarat", "Gujarat"],
  ["himachal", "Himachal Pradesh"],
  ["himanchal", "Himachal Pradesh"],
  ["himachal pradesh", "Himachal Pradesh"],
  ["uttarakhand", "Uttarakhand"],
  ["uttrakhand", "Uttarakhand"],
  ["rajasthan", "Rajasthan"],
  ["goa", "Goa"],
  ["kerala", "Kerala"],
  ["maharashtra", "Maharashtra"],
  ["karnataka", "Karnataka"],
  ["delhi", "Delhi"],
  ["new delhi", "Delhi"],
  ["uttar pradesh", "Uttar Pradesh"],
  ["madhya pradesh", "Madhya Pradesh"],
  ["west bengal", "West Bengal"],
  ["tamil nadu", "Tamil Nadu"],
  ["telangana", "Telangana"],
  ["punjab", "Punjab"],
  ["haryana", "Haryana"],
  ["ladakh", "Ladakh"],
]);

const CITY_STATE_FALLBACKS = new Map([
  ["udaipur", "Rajasthan"],
  ["jaipur", "Rajasthan"],
  ["jaisalmer", "Rajasthan"],
  ["jodhpur", "Rajasthan"],
  ["alappuzha", "Kerala"],
  ["alleppey", "Kerala"],
  ["kochi", "Kerala"],
  ["munnar", "Kerala"],
  ["kumarakom", "Kerala"],
  ["alibaug", "Maharashtra"],
  ["mumbai", "Maharashtra"],
  ["lonavala", "Maharashtra"],
  ["mahabaleshwar", "Maharashtra"],
  ["anjuna", "Goa"],
  ["arpora", "Goa"],
  ["assagao", "Goa"],
  ["baga", "Goa"],
  ["calangute", "Goa"],
  ["candolim", "Goa"],
  ["palolem", "Goa"],
  ["vagator", "Goa"],
  ["shimla", "Himachal Pradesh"],
  ["manali", "Himachal Pradesh"],
  ["rishikesh", "Uttarakhand"],
  ["bengaluru", "Karnataka"],
  ["bangalore", "Karnataka"],
  ["ahmedabad", "Gujarat"],
  ["surat", "Gujarat"],
  ["vadodara", "Gujarat"],
  ["dwarka", "Gujarat"],
]);

const titleCase = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\b[a-z]/g, (char) => char.toUpperCase());

export const normalizeStateName = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const key = raw.toLowerCase();
  return STATE_ALIASES.get(key) || titleCase(raw);
};

export const isKnownStateName = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  return Boolean(raw && STATE_ALIASES.has(raw));
};

export const resolveStateName = (item, fallback = "") => {
  const state = normalizeStateName(item?.state || item?.region || item?.parent_name || "");
  if (state) return state;

  const candidates = [
    item?.city,
    item?.name,
    item?.display_name,
    item?.label,
    item?.slug,
    fallback,
  ];

  for (const candidate of candidates) {
    const firstPart = String(candidate || "").split(",")[0].trim().toLowerCase();
    if (!firstPart) continue;
    const directState = STATE_ALIASES.get(firstPart);
    if (directState) return directState;
    const inferredState = CITY_STATE_FALLBACKS.get(firstPart);
    if (inferredState) return inferredState;
  }

  return normalizeStateName(fallback);
};

export const stateSearchParams = (stateName) => {
  const params = new URLSearchParams();
  if (!stateName) return params;
  params.set("location", stateName);
  params.set("city", stateName);
  params.set("destination", stateName);
  params.set("location_type", "state");
  return params;
};
